import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { ApiJsonDateParserInterceptor } from './lib/api-json-date-parser.interceptor';

export * from './lib/api-json-date-parser.interceptor';

export function provideApiJsonDateParser(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiJsonDateParserInterceptor,
      multi: true,
    },
  ]);
}
